import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ParametroService } from 'src/app/services/parametro.service';
import { Parametro } from 'src/app/models/Parametro';
import { ModalMpComponent } from '../modal-mp/modal-mp.component';
import { Fur } from 'src/app/models/Fur';
import { ExpedienteComponent } from '../expediente/expediente.component';
import { NumIdParamLeyMPD, rutaDocs, saveContent } from 'src/app/general/variables';
import { ModalInstruccionesMpComponent } from '../modal-instrucciones-mp/modal-instrucciones-mp.component';
import { General } from 'src/app/models/General';

@Component({
  selector: 'app-contenedor-mp',
  templateUrl: './contenedor-mp.component.html',
  styleUrls: ['./contenedor-mp.component.css']
})
export class ContenedorMpComponent implements OnInit {

  @Output() opSolicitaMPB = new EventEmitter() ;

  @ViewChild(ExpedienteComponent) expedienteC: ExpedienteComponent;
  pTitulo: Parametro = new Parametro();
  pTitulo2: Parametro = new Parametro();
  pCuerpo: Parametro = new Parametro();
  flgAcepto = false;
  flgSolicita = false;
  flgLectura = false;
  flgEsFur = false;
  strDscUrlLey = 'Ley_29542.pdf';
  strDscUrlLey2 = 'ReglamentoLey.pdf';

  constructor(public dialog: MatDialog,
              protected parametroService: ParametroService,
    ) { }

  ngOnInit() {

    this.parametroService.obtenerParametro(1).subscribe(
      data => {
        this.pTitulo = data;
        // console.log("=======================0Obtener Parametro");
        // console.log(data);
        // this.formHechos.controls.select_canal.setValue(5);
      }
    );

    this.parametroService.obtenerParametro(2).subscribe(
      data => {
        this.pTitulo2 = data;

        // (<HTMLInputElement>document.getElementById("id_tenor_ley")).innerText = this.pTitulo2.cparamValor;

      }
    );

    this.parametroService.obtenerParametro(3).subscribe(
      data => {
        this.pCuerpo = data;
        // console.log(data);
        // this.formHechos.controls.select_canal.setValue(5);
      }
    );


  }

  AbrirInstrucciones() {

    const dialogRef = this.dialog.open(ModalInstruccionesMpComponent, { width: '70%',
    data: this.pTitulo}); // height: '70%'

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });

  }

  CambioSolicita(flgEvent) {

    this.flgSolicita = flgEvent.checked;

  }

  medidaProteccionCReadEnable() {
    console.log('Medidas de protección lectura true ');
    this.flgLectura = true;
  }

  medidaProteccionCReadDisable() {
    this.flgLectura = false;
  }

  setMedidaProteccionC(fur: Fur) {
    if (fur.cfurCodtipo == 'FUR') {
      this.flgEsFur = true;
   }
    this.flgAcepto = fur.denunciante.cdenuncianteFlgconfleyprot == 'SI' ? true : false;
    this.flgSolicita = fur.denunciante.cdenuncianteFlgacepmedpyb == 'SI' ? true : false;
    console.log('Flag es fur: ' + this.flgEsFur);
  }

  CambioAcepto(flgEvent) {

    this.setFlgAcepto(flgEvent.checked);

    // let vGeneral : General;

    // this.flgAcepto = flgEvent.checked;

    // if(!this.flgAcepto)
    // {

    //   this.flgSolicita = false;

    //   vGeneral = new General();

    //   vGeneral.flgCampo1 = false;
    //   vGeneral.flgCampo2 = true;
    //   vGeneral.flgCampo3 = true; //Desactiva por pestaña MDPB

    //   console.log("====vGeneral",vGeneral);

    //   this.opSolicitaMPB.emit(vGeneral);

    // }


  }


  setFlgAcepto(flgChecked: boolean) {

    let vGeneral: General;

    this.flgAcepto = flgChecked;

    if (!this.flgAcepto) {

      this.flgSolicita = false;

      vGeneral = new General();

      vGeneral.flgCampo1 = false;
      vGeneral.flgCampo2 = true;
      vGeneral.flgCampo3 = true; // Desactiva por pestaña MDPB

      console.log('====vGeneral', vGeneral);

      this.opSolicitaMPB.emit(vGeneral);

    }


  }

  _abrirUrl(dscNombre: string) {

    // window.open(url, '_blank');
    saveContent(rutaDocs + dscNombre, dscNombre);

  }

}
